import { render, staticRenderFns } from "./Infographic6.vue?vue&type=template&id=6c8b5512&scoped=true&"
import script from "./Infographic6.vue?vue&type=script&lang=js&"
export * from "./Infographic6.vue?vue&type=script&lang=js&"
import style0 from "./Infographic6.vue?vue&type=style&index=0&id=6c8b5512&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8b5512",
  null
  
)

export default component.exports